import { NavLink } from "react-router-dom";
import "./admin.css";

export const AdministrationUnitsLinks = () => {
    return (
        <div className="links">
            <NavLink to="/administration/prathinidyogam" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>Prathinidyogam</NavLink>
            <NavLink to="/administration/kendrasamathi" className={({ isActive }) => isActive ? "active-linking linking" : "linking"}>Kendrasamathi</NavLink>
        </div>
    )
}

export const Prath = () => {
    return (
        <div class="content1">
            <AdministrationUnitsLinks />
            <h2>PRATHINIDHI YOGAM</h2>
            <div class="units-page">
                <div class="admins-descp">
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!</p>
                </div>
                <div class="unit-group">
                    <img src="/images/cat-gp.jpg" alt="PRATHINIDHI YOGAM 2025 - 2028" />
                    <h3>PRATHINIDHI YOGAM 2025 - 2028</h3>
                </div>
                <div class="admembers-table">
                    <table border="1" style={{ width: "50%" }}>
                        <tr>
                            <th>Member Name</th>
                            <th>Contact Number</th>
                        </tr>
                        <tr>
                            <td>Name 1</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Name 2</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Name 3</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Name 4</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    );
};

export const Kendra = () => {
    return (
        <div class="content1">
            <AdministrationUnitsLinks />
            <h2>KENDRA SAMTHI</h2>
            <div class="admin-page">
                <div class="admins-descp">
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!</p>
                </div>
                <div class="unit-group">
                    <img src="/images/cat-gp.jpg" alt="KENDRA SAMTHI 2025 - 2026" />
                    <h3>KENDRA SAMTHI 2025 - 2026</h3>
                </div>
                <div class="admembers-table">
                    <table border="1" style={{ width: "50%" }}>
                        <tr>
                            <th>Member Name</th>
                            <th>Contact Number</th>
                        </tr>
                        <tr>
                            <td>Name 1</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Name 2</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Name 3</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                        <tr>
                            <td>Name 4</td>
                            <td><a href="tel:+91XXXXXXXXXX" style={{ textDecoration: "none", fontSize: "18px" }}>☎️ +91 XXXXXXXXXX</a></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    );
};